import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { Nav } from "./common/components/nav";

import { ClientPreferences, ClientUnsubscribe, CurrentCandidatePipelinePage, CandidateSignup, CandidateUnsubscribe } from './pages';

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={
          <CandidateSignup />
        } />
        <Route path="/bd" element={
          <ClientPreferences />
        } />
        <Route path="/bd/unsubscribe" element={
          <ClientUnsubscribe />
        } />
        <Route path="/top_prospects" element={
          <CurrentCandidatePipelinePage />
        } />
        <Route path="/candidate" element={
          <CandidateSignup />
        } />
        <Route path="/candidate/unsubscribe" element={
          <CandidateUnsubscribe />
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
